import React, {Component} from 'react';
import {connect} from "react-redux";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';

class HeaderConfiguration extends Component {
    constructor(props){
        super(props);
        const optionData = this.props.clickedNodeInfo.extras.options
        this.state = {
            logDecisionName: typeof optionData.logDecisionName !== 'undefined' && optionData.logDecisionName !== null  ? optionData.logDecisionName : '',
            totalItemCount: typeof optionData.totalItemCount !== 'undefined' && optionData.totalItemCount !== null ? optionData.totalItemCount : '',
            checkLimitCount: typeof optionData.totalItemCount !== 'undefined' && optionData.totalItemCount !== null && optionData.totalItemCount !== '' ? true: false,
            checkSingleIteration: typeof optionData.checkSingleIteration !== 'undefined' && optionData.checkSingleIteration !== null ? optionData.checkSingleIteration : false
        }
        this.checkSingleIteration = this.checkSingleIteration.bind(this);
        this.checkLimitInput = this.checkLimitInput.bind(this);
        this.inputHandle = this.inputHandle.bind(this);
        this.sendData = this.sendData.bind(this);
    }

    // componentDidMount(){
    //     const optionData = this.props.clickedNodeInfo.extras.options
    //     const logDecisionName = typeof optionData.logDecisionName !== 'undefined' && optionData.logDecisionName !== null  ? optionData.logDecisionName : '';
    //     const totalItemCount = typeof optionData.totalItemCount !== 'undefined' && optionData.totalItemCount !== null ? optionData.totalItemCount : '';
    //     const checkSingleIteration = typeof optionData.checkSingleIteration !== 'undefined' && optionData.checkSingleIteration !== null ? optionData.checkSingleIteration : false;
    //
    //     this.setState({
    //         logDecisionName: logDecisionName,
    //         totalItemCount: totalItemCount,
    //         checkLimitCount: totalItemCount !== '' ? true : false,
    //         checkSingleIteration: checkSingleIteration
    //     });
    //
    //     console.log(optionData);
    //     console.log("componentMount");
    // }

    checkLimitInput() {
        const checkLimitCount = !this.state.checkLimitCount;
        this.setState({
            checkLimitCount: checkLimitCount,
            totalItemCount: checkLimitCount ? this.state.totalItemCount : '' 
        }, () => this.sendData());
    }

    checkSingleIteration() {
        const checkSingleIteration = !this.state.checkSingleIteration;
        this.setState({
            checkSingleIteration: checkSingleIteration
        }, () => this.sendData());
    }

    sendData(){
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        clickedNodeInfo.extras.options.logDecisionName = this.state.logDecisionName;
        clickedNodeInfo.extras.options.totalItemCount = this.state.checkLimitCount ? this.state.totalItemCount : '';
        clickedNodeInfo.extras.options.checkSingleIteration = this.state.checkSingleIteration;
        clickedNodeInfo.extras.name = clickedNodeInfo.name;
        this.props.clickedNodeAction(clickedNodeInfo);
    }

    inputHandle(e){
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    render() {
        const {nodeName} = this.props;
        return (
            <header className="header-configuration">
                <div className="box">
                    <div className="item">
                        <span className="box-title">Log Decision Name</span>
                    </div>
                    <div className="item">
                        <div className="input-wrapper">
                            <input className="panel-input" onChange={this.inputHandle} onBlur={this.sendData}  type="text" name="logDecisionName" value={this.state.logDecisionName} placeholder="Log Decision Name"/>
                        </div>
                    </div>

                        <div className="item">
                            <label className="checkbox-area">
                                <input type="checkbox" checked={this.state.checkLimitCount} onChange={this.checkLimitInput} className="checkbox" defaultValue="1"/>
                                <span className="name">Limit Count</span>
                            </label>
                        </div>
                        <div className={this.state.checkLimitCount ? 'item' : 'item hidden'}>
                            <input className="panel-input" name="totalItemCount" onChange={this.inputHandle} onBlur={this.sendData} value={this.state.totalItemCount} type="number" min="1" placeholder="Total Item Count"/>
                        </div>
                    { nodeName !== 'switch' && (
                        <div className="item">
                            <label className="checkbox-area">
                                <input type="checkbox" checked={this.state.checkSingleIteration} onChange={this.checkSingleIteration} className="checkbox" defaultValue="1"/>
                                <span className="name">Single Iteration</span>
                            </label>
                        </div>
                    )}
                </div>
            </header>
        )
    }
}


function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
    }
}
export default connect(mapStateToProps, {clickedNodeAction})(HeaderConfiguration);